import React from "react";
import { api_capturePayment } from "../api/Api";

export function PaymentSuccess() {

    const [captureResponse, setCaptureResponse] = React.useState(null);
    const [message, setMessage] = React.useState("Completing payment...");

    React.useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const orderId = params.get("token");

        if (!orderId) {
            setMessage("Missing PayPal order ID.");
            return;
        }

        api_capturePayment(
            orderId,
            data => {
                setCaptureResponse(data);
                setMessage(data.message);
            },
            errorMessage => {
                setMessage(errorMessage);
            }
        );

    }, []);

    function formatBookingDateTime(value) {

        const date = new Date(value);

        return {
            date: date.toLocaleDateString("en-GB", {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric"
            }),
            time: date.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit"
            })
        };
    }

    return (
        <div className="content-inner main-block content-wide">
            <div className="narrow">

                <h1>Booking confirmation</h1>

                <p>{message}</p>

                {captureResponse && (
                    <>
                        <p>
                            Your lesson is booked for:
                        </p>

                        <p>
                            <strong>
                                {formatBookingDateTime(captureResponse.start).date}
                                <br />
                                {formatBookingDateTime(captureResponse.start).time}
                            </strong>
                        </p>

                        <p>
                            <a
                                className="booking-calendar-download"
                                href={`/api/calendar/${captureResponse.calendarToken}`}
                            >
                                📅 Add this lesson to your calendar
                            </a>
                        </p>
                    </>
                )}

            </div>
        </div>
    );

}